import { JobTitle } from '../../../domain/types';
import { useAgent, useCurrentAgentSync } from '../../../hooks/use-agent/useAgent';

export function useIsAreaManagerOfAgent(agentIdOrEmail?: string | number) {
  const { data: currentAgent } = useCurrentAgentSync();
  const { data: agent } = useAgent(agentIdOrEmail);

  return !!currentAgent && currentAgent?.id === agent?.areaManagerId && ![JobTitle.AGENTE, JobTitle.CONSULENTE].includes(currentAgent.jobTitle);
}
